import { Component, HostListener, ElementRef, Inject, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { HelperService } from 'src/app/core/helper/helper.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AuthService } from '../../auth/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/core/services/common.service';
import * as CryptoJS from "crypto-js";

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html'
})
export class WarningComponent {

  @Output() authSuccess = new EventEmitter<boolean>(false);
  private hasEmitted = false;
  getImagePath: any = environment.image_path;

  signUpForm!: FormGroup;
  verifyEmailForm!: FormGroup;
  verifyPhoneNumberForm!: FormGroup;
  emailVerifed = false;
  phoneVerifed = false;
  hideConfirmPassword: boolean = true;
  hidePassword: boolean = true;
  isSame: boolean = true;
  public dial_code: any = "";
  public phone_number: any = "";
  public final_phone_number: any = "";
  PhoneNumberFormat = PhoneNumberFormat;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  maxLength = 15;
  submitted = false;
  isLoginForm: boolean = false;
  loginForm!: FormGroup;
  loginFormSubmitted: boolean = false;
  projectID: any;
  formDataArray: any[] = [];
  getStoredData: any = this.commonService.getQuoteStoredData();
  title: string = '';

  toggleForm() {
    this.isLoginForm = !this.isLoginForm;
  }

  emailOtpConfig: any = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    containerClass: "otp-input-container",
    inputClass: "custom-otp-input",
  };

  phoneOtpConfig: any = {
    allowNumbersOnly: false,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    containerClass: "otp-input-container",
    inputClass: "custom-otp-input",
  };

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India];
  }

  constructor(public dialogRef: MatDialogRef<WarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private helper: HelperService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private modalService: NgbModal,
    private cookieService: CookieService,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef
  ) { }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onAuthSuccess(value:boolean) {
    if (!this.hasEmitted) {  // Add this check
      this.hasEmitted = true;  // Set the flag
      this.authSuccess.emit(true);
  }
  }

  ngOnInit(): void {
    // if (this.data.source === 'submitBOMFile') {
    //   this.title = 'Sign In';
    // } else if (this.data.source === 'showWarningModal') {
    //   this.title = 'Warning for BOM Submission';
    // }
    this.projectID = localStorage.getItem('projectID');
    this.signUpForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+(?:\.[a-zA-Z]{1,5}){0,2}\.[a-zA-Z]{2,3}$'
        ),
      ]),
      phone: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(/^(?!.*\s).*$/)]),
      confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(/^(?!.*\s).*$/)]),
    });

    this.verifyEmailForm = new FormGroup({
      iUserOtpId: new FormControl(""),
      vEmailId: new FormControl(""),
      iOTP: new FormControl("", [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });

    this.verifyPhoneNumberForm = new FormGroup({
      iUserOtpId: new FormControl(""),
      vPhoneNo: new FormControl(""),
      iOTP: new FormControl("", [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    });

    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(
          '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+(?:\.[a-zA-Z]{1,5}){0,2}\.[a-zA-Z]{2,3}$'
        ),
      ]),
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20), Validators.pattern(/^(?!.*\s).*$/)]),
    });
    setTimeout(()=>{
      this.initializeFormWithStoredData();
    },1000)

    this.commonService.initPhoneFields();
  }

  ngOnDestroy() {
    this.authSuccess.complete();  
    this.modalService.dismissAll();
    this.commonService.stopObserving();
}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Check if the click was outside the modal
    const clickedInside = this.elRef.nativeElement.contains(event.target);
    if (clickedInside) {
      this.storeIndividualFormData();
    }
  }

  storeIndividualFormData() {
    const formValues = this.signUpForm.value;

    // Store individual values if they are valid
    if (formValues.name) {
      this.updateFormDataArray('name', formValues.name);
    }
    if (formValues.email) {
      this.updateFormDataArray('email', formValues.email);
    }
    if (formValues.phone) {
      this.updateFormDataArray('phone', formValues.phone);
    }
    if (formValues.password) {
      this.updateFormDataArray('password', formValues.password);
    }
    if (formValues.confirmPassword) {
      this.updateFormDataArray('confirmPassword', formValues.confirmPassword);
    }
  }

  updateFormDataArray(field: string, value: string) {
    const existingIndex = this.formDataArray.findIndex(data => data.field === field);
    if (existingIndex > -1) {
      // Update existing entry
      this.formDataArray[existingIndex].value = value;
    } else {
      // Add new entry
      this.formDataArray.push({ field, value });
    }
    let temp = {
      emailverified: this.emailVerifed,
      phoneverified: this.phoneVerifed,
      formArray: this.formDataArray
    }
    this.commonService.updateQuoteStoredData(temp);
  }

  storeData: any = []
  initializeFormWithStoredData() {
    this.storeData = this.getStoredData()
    if(this.storeData.formArray && this.storeData.formArray.length>0){
      this.emailVerifed = this.storeData.emailverified;
      this.phoneVerifed = this.storeData.phoneverified;
  
      const formValues = {
        email: this.storeData.formArray.find((item: any) => item.field === 'email')?.value || '',
        name: this.storeData.formArray.find((item: any) => item.field === 'name')?.value || '',
        phone: this.storeData.formArray.find((item: any) => item.field === 'phone')?.value || '',
        password: this.storeData.formArray.find((item: any) => item.field === 'password')?.value || '',
        confirmPassword: this.storeData.formArray.find((item: any) => item.field === 'confirmPassword')?.value || ''
      };
      this.signUpForm.patchValue(formValues);
    }else{
      const formValues = {
        email: '',
        name: '',
        phone: '',
        password: '',
        confirmPassword: ''
      };
      this.signUpForm.patchValue(formValues);
    }
  }

  openModal() {
    this.initializeFormWithStoredData();
    // Logic to open the modal
  }

  VerifyEmailModel(modelName: any) {
    if (this.signUpForm.value.email) {
      this.dialog.closeAll();
      this.SentEmailOTP("verifyEmailModel", modelName);
    }
  }

  VerifyPhoneModel(modelName: any) {
    this.submitted = false;
    if (!this.signUpForm.controls['phone'].invalid) {
      this.dialog.closeAll();
      this.SentPhoneOTP("verifyPhoneModel", modelName);
    } else {
      this.notificationService.showError("Invalid! Please check the number.", "");
    }
  }

  ResendPhoneOTP() {
    if (this.signUpForm.value.phone) {
      this.SentPhoneOTP("ResendPhoneOTP", "");
    }
  }

  async SentPhoneOTP(type: any, modelName: any) {
    this.dial_code = this.signUpForm.value.phone.dialCode;
    this.phone_number = this.signUpForm.value.phone.e164Number;
    this.final_phone_number = this.phone_number.replace(this.dial_code, "");

    let temp = {
      iType: 2,
      vDialCode: this.dial_code,
      vPhoneNo: this.final_phone_number,
    };
    let enc: any = await this.helper.staticPush(JSON.stringify(temp));

    let reqData = {
      data: enc,
    };

    this.authService.GetOtp(reqData).subscribe(async (result: any) => {
      if (result.code == 200) {
        let tempDecryptData: any = await this.helper.staticPop(result["data"]);
        if (type == "verifyPhoneModel") {
          this.modalService.open(modelName, { centered: true, windowClass: "verify-email-modal" });
        }
        this.verifyPhoneNumberForm.controls['iUserOtpId'].patchValue(tempDecryptData["iUserOtpId"]);
        this.verifyPhoneNumberForm.controls['vPhoneNo'].patchValue(tempDecryptData["vPhoneNo"]);
        this.notificationService.showSuccess(result.message, "");
      } else {
        this.notificationService.showError(result.message, "");
        this.isModalOpen = true;
        this.dialog.open(WarningComponent, {
          width: '500px',
        });
      }
    });
  }

  OnPhoneNumberOtpChange(otp: any) {
    if (otp.length == this.phoneOtpConfig.length) {
      this.verifyPhoneNumberForm.controls['iOTP'].setValue(otp);
    } else {
      this.verifyPhoneNumberForm.controls['iOTP'].setValue(otp);
    }
  }

  ResendEmailOTP() {
    if (this.signUpForm.value.email) {
      this.SentEmailOTP("ResendEmailOTP", "");
    }
  }

  async SentEmailOTP(type: any, modelName: any) {

    let temp = {
      iType: 1,
      vEmailId: this.signUpForm.value.email,
    };
    let enc: any = await this.helper.staticPush(JSON.stringify(temp));

    let reqData = {
      data: enc,
    };


    this.authService.GetOtp(reqData).subscribe(async (result: any) => {
      if (result.code == 200) {
        let tempDecryptData: any = await this.helper.staticPop(result["data"]);

        this.verifyEmailForm.controls['iUserOtpId'].patchValue(tempDecryptData["iUserOtpId"]);
        this.verifyEmailForm.controls['vEmailId'].patchValue(tempDecryptData["email"]);
        if (type == "verifyEmailModel") {
          this.modalService.open(modelName, { centered: true, windowClass: "verify-email-modal" });
        }
        this.notificationService.showSuccess(result.message, "");
      } else {
        this.notificationService.showError(result.message, "");
        this.isModalOpen = true;
        this.dialog.open(WarningComponent, {
          width: '500px',
        });
      }
    });
  }

  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }


  async SignUp() {
    this.dial_code = this.signUpForm.value.phone.dialCode;
    this.phone_number = this.signUpForm.value.phone.e164Number;
    this.final_phone_number = this.phone_number.replace(this.dial_code, "");


    if (this.signUpForm.invalid || this.isSame === false) {
      this.signUpForm.markAllAsTouched();
      return;
    }
 
    // if (!this.emailVerifed && !this.phoneVerifed) {
    //   this.notificationService.showError("Please verify Email and phone number", "");
    //   return;
    // }

    // if (!this.emailVerifed) {
    //   this.notificationService.showError("Please verify Email", "");
    //   return;
    // }

    // if (this.emailVerifed && !this.phoneVerifed) {
    //   this.notificationService.showError("Please verify phone number", "");
    //   return;
    // }
    // const phoneData = this.storeData.formArray.find((item: any) => item.field === 'phone');
    // const vDialCode = phoneData ? phoneData.value.dialCode : '';
    // const vPhoneNo = phoneData ? phoneData.value.number.replace(/\s+/g, '').replace(/^0+/, '') : '';

    let reqData = {
      iProjectID: this.projectID,
      vEmailId: this.signUpForm.value.email.toLowerCase(),
      vName: this.signUpForm.value.name,
      vDialCode: this.dial_code,
      vPhoneNo: this.final_phone_number,
      txPassword: this.signUpForm.value.confirmPassword,
      vCountryCode: this.signUpForm.controls["phone"].value.countryCode,
      tiAccountType: 4
    };

    let eData: any = await this.helper.dynamicPush(JSON.stringify(reqData));

    let reqJSON = {
      data: eData
    };

    let notificationData = {
      iUserId: null,
      vNotificationTitle: "New Quote Requested",
      vNotificationBody: `${this.signUpForm.value.name} is trying to get a new Quote, assist them further`,
      txNotificationRoute: '/member/role-management/users',
    }

    // API Call Goes Here
    this.authenticationService.SignUpAuth(reqJSON).subscribe((result: any) => {
      if (result.code == 200) {
        this.notificationService.showSuccess(`${result.message}`, "");
        this.authService.setToken(result.data.txAccessToken);

        this.onAuthSuccess(true);
        this.modalService.dismissAll();
        this.dialog.closeAll();
        this.signUpForm.reset();

        this.formDataArray = []; // Empty the array
        this.emailVerifed = false; // Set email verification to false
        this.phoneVerifed = false; // Set phone verification to false

        
        this.commonService.setQuoteCallback();

        this.notificationService.addNotification(notificationData).subscribe((result: any) => {
          if (result.code == 200) {
            // console.log(result, 'result in notification');
          }
          else
            console.log('Error in notification');
        });

        let temp = {
          emailverified: this.emailVerifed,
          phoneverified: this.phoneVerifed,
          formArray: this.formDataArray
        };
        this.commonService.updateQuoteStoredData(temp);

 
        let JSONData = {
          userType: reqData.tiAccountType,
          userEmail: this.signUpForm.value?.email?.toLowerCase() || null,
          accessToken: result.data.txAccessToken,
          refreshToken: result.data.txRefreshToken
        };
        let cookieData = CryptoJS.AES.encrypt(JSON.stringify(JSONData), this.helper.GetCookieKey()).toString();
        this.cookieService.set("customer_user", cookieData, undefined, '/');
      } else {
        // this.emailVerifed = false
        this.notificationService.showError(`${result.message}`, "");
      }
    });
  }

  async HandleLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    } else {
    }
    this.loginFormSubmitted = true;

    let data = {
      vEmailId: this.loginForm.value.email.toLowerCase(),
      txPassword: this.loginForm.value.password,
      iProjectID: this.projectID
    };
    let eData: any = await this.helper.dynamicPush(JSON.stringify(data));

    let reqJSON = {
      data: eData,
    };

    let notificationData = {
      iUserId: null,
      vNotificationTitle: "New Quote Requested!!",
      vNotificationBody: `is trying to get a new Quote, assist them further`,
      txNotificationRoute: '/member/quotation-proposal',
    }

    this.authenticationService.SignInAuth(reqJSON).subscribe((result: any) => {
      if (result.code == 200) {
        this.notificationService.showSuccess(`${result.message}`, "");

        this.authService.setToken(result.data.txAccessToken);
        this.onAuthSuccess(true);
        this.cookieService.delete("customer_user", '/');
        this.modalService.dismissAll();
        this.dialog.closeAll();
        

        let JSONData = {
          userType: result.data.tiAccountType,
          userEmail: this.loginForm.value.email.toLowerCase(),
          accessToken: result.data.txAccessToken,
          refreshToken: result.data.txRefreshToken
        };

        let cookieData = CryptoJS.AES.encrypt(JSON.stringify(JSONData), this.helper.GetCookieKey()).toString();
        this.cookieService.set("customer_user", cookieData, undefined, '/');

        localStorage.setItem("customer_account_type", result.data.tiAccountType)
        if (this.loginForm.value.rememberMe) {
          localStorage.setItem("customer_remember_me", this.loginForm.value.rememberMe)
        }

        this.loginForm.reset();
        this.commonService.setQuoteCallback();

        this.notificationService.addNotification(notificationData).subscribe((result: any) => {
          if (result.code == 200) {
            console.log(result, 'result in notification');
          }
          else
            console.log('Error in notification');
        });
      } else {
        this.notificationService.showError(`${result.message}`, "");
      }
    });

  }

  comparePassword() {
    const { password, confirmPassword } = this.signUpForm.value;
   
   this.isSame = password === confirmPassword && password && confirmPassword;
   
   if (!this.isSame) {
     console.log('Passwords do not match.');
   }
  }

  OnEmailOtpChange(otp: any) {
    if (otp.length == this.emailOtpConfig.length) {
      this.verifyEmailForm.controls['iOTP'].setValue(otp);
    } else {
      this.verifyEmailForm.controls['iOTP'].setValue(otp);
    }
  }
  private isModalOpen = false;

  async VerifyEmail() {
    this.submitted = true;
    if (this.verifyEmailForm.invalid) {
      return;
    }

    let enc: any = await this.helper.staticPush(JSON.stringify(this.verifyEmailForm.value));

    let reqData = {
      data: enc,
    };
    this.authService.VerifyOtp(reqData).subscribe((result: any) => {
      if (result.code == 200) {
        this.isModalOpen = true;
        this.dialog.open(WarningComponent, {
          width: '500px',

        });
        this.modalService.dismissAll();
        let storedDetails = this.getStoredData();
        this.emailVerifed = true;
        let temp = {
          emailverified: this.emailVerifed,
          phoneverified: storedDetails.phoneverified,
          formArray: storedDetails.formArray
        }
        this.commonService.updateQuoteStoredData(temp);
        this.notificationService.showSuccess(result.message, "");
      } else {
        this.notificationService.showError(result.message, "");
      }
    });
  }

  async VerifyPhoneNumber() {
    this.submitted = true;
    if (this.verifyPhoneNumberForm.invalid) {
      return;
    }

    let enc: any = await this.helper.staticPush(JSON.stringify(this.verifyPhoneNumberForm.value));

    let reqData = {
      data: enc,
    };

    this.authService.VerifyOtp(reqData).subscribe((result: any) => {
      if (result.code == 200) {
        this.isModalOpen = true;
        this.dialog.open(WarningComponent, {
          width: '500px',
        });
        this.modalService.dismissAll();
        this.signUpForm.controls["phone"].disable();
        let storedDetails = this.getStoredData();
        this.phoneVerifed = true;
        let temp = {
          emailverified: storedDetails.emailverified,
          phoneverified: this.phoneVerifed,
          formArray: storedDetails.formArray
        }
        this.commonService.updateQuoteStoredData(temp);
        this.notificationService.showSuccess(result.message, "");
      } else {
        this.notificationService.showError(result.message, "");
      }
    });
  }
}
